module.exports = __webpack_public_path__ + "img/dep_tobacco@2x.5951c275.png";